<template lang="pug">
front-regular-modal(ref="warningModal" :title="$t('termsUpdate2022.title')" width="600px" @closed="onClosed" :click-to-close="true")
    div
      p {{ $t('termsUpdate2022.line1') }}
      p {{ $t('termsUpdate2022.line2') }}
      p {{ $t('termsUpdate2022.line3') }}
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import FrontRegularModal from "@/views/pages/global/modals/FrontRegularModal.vue";
import Cookies from "js-cookie";

const COOKIE_NAME = 'walletoTermsUpdate2022Alert';

@Component({
  name: "WalletoTermsUpdate2022Alert",
  components: {FrontRegularModal}
})
export default class WalletoTermsUpdate2022Alert extends Vue {
  @Prop({default: false})
  enabled: boolean

  mounted() {
    if (this.enabled && !this.isWindowClosedByUser)
      this.showMessage();
  }

  onClosed() {
    this.rememberClose();
  }

  rememberClose() {
    if (this.localStorageSupported) {
      localStorage.setItem(COOKIE_NAME, '1');
    }
    Cookies.set(COOKIE_NAME, '1');
  }

  localStorageSupported = true;

  checkLocalStorageSupported() {
    try {
      localStorage.setItem(`${COOKIE_NAME}_test`, 'cryptoNewsModalTest');
      localStorage.removeItem(`${COOKIE_NAME}_test`);
      return true;
    } catch (e) {
      return false;
    }
  }

  get isWindowClosedByUser() {
    const res = this.localStorageSupported && localStorage.getItem(COOKIE_NAME)
      || Cookies.get(COOKIE_NAME) || false;
    return res === '1';
  }

  created() {
    this.localStorageSupported = this.checkLocalStorageSupported();
  }

  showMessage() {
    (this.$refs.warningModal as FrontRegularModal).showModal();
  }
}
</script>

<style scoped lang="less">

</style>

<i18n>
{
  "ru": {
    "termsUpdate2022": {
      "title": "Обновление условий использования карт Visa",
      "line1": "Пожалуйста, обратите внимание на изменения в Условиях использования системы Capitalist, в части открытия и обслуживания счетов IBAN и платежных счетов, выпускаемых Walletto UAB.",
      "line2": "К плате за услугу добавляется \"Плата за закрытие счета\", которая составляет 25,00 евро.",
      "line3": "Данная комиссия действует с 01.02.2023."
    }
  },
  "en": {
    "termsUpdate2022": {
      "title": "Update of terms of use of Visa cards",
      "line1": "Please be informed about the changes in the Terms and Conditions of Capitalist system, in the part of the opening and maintenance FEEs of IBAN and Payment accounts issued by Walletto UAB.",
      "line2": "The \"Account closure fee\" is added to the service fees - set as 25,00 EUR.",
      "line3": "This commission is effective from 01.02.2023."
    }
  }
}
</i18n>
